import React from "react";

export default function PrivacyPolicy() {
  return (
    <main
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "120px 24px 80px",
        lineHeight: "1.7",
        color: "#1a1a1a",
      }}
    >
      <h1>Politique de confidentialité – Dieli</h1>

      <p>Dernière mise à jour : 18 septembre 2026</p>

      <p>
        La présente politique de confidentialité explique comment Dieli collecte,
        utilise et protège les données personnelles des utilisateurs de ses
        services, notamment l'application Dieli destinée aux passagers et
        l'application Dieli Driver destinée aux chauffeurs.
      </p>

      <h2>1. Responsable du traitement</h2>

      <p>
        Le service Dieli est exploité par ON THE ROAD.
        Pour toute question relative à vos données personnelles, vous pouvez
        nous contacter à l'adresse suivante : vtcontheroad@gmail.com.
      </p>

      <h2>2. Données collectées</h2>

      <p>
        Selon votre utilisation de Dieli, nous pouvons collecter les catégories
        de données suivantes :
      </p>

      <ul>
        <li>informations de compte et coordonnées ;</li>
        <li>données nécessaires à l'authentification ;</li>
        <li>données de localisation ;</li>
        <li>adresses de départ, destinations et étapes d'une course ;</li>
        <li>historique des courses et réservations ;</li>
        <li>informations relatives aux catégories de véhicules sélectionnées ;</li>
        <li>données techniques nécessaires au fonctionnement de l'application ;</li>
        <li>identifiants permettant l'envoi de notifications ;</li>
        <li>
          pour les chauffeurs, informations et documents nécessaires à la
          vérification et à la gestion de leur compte professionnel.
        </li>
      </ul>

      <h2>3. Géolocalisation</h2>

      <p>
        Dieli utilise la localisation du passager afin notamment de déterminer
        son lieu de prise en charge, d'afficher les chauffeurs disponibles à
        proximité et d'assurer le suivi de la course.
      </p>

      <p>
        Dieli Driver peut utiliser la localisation du chauffeur lorsqu'il est
        en ligne, y compris en arrière-plan lorsque cela est nécessaire au
        fonctionnement du service, afin de proposer des courses à proximité,
        permettre la mise en relation avec les passagers et assurer le suivi
        des courses.
      </p>

      <p>
        Les autorisations de localisation peuvent être modifiées à tout moment
        depuis les réglages de l'appareil.
      </p>

      <h2>4. Paiements</h2>

      <p>
        Les paiements effectués dans Dieli sont traités par notre prestataire
        de paiement Stripe. Dieli n'a pas vocation à stocker directement les
        données complètes de carte bancaire des utilisateurs. Les informations
        de paiement sont traitées conformément aux règles de sécurité et aux
        conditions du prestataire de paiement.
      </p>

      <h2>5. Notifications</h2>

      <p>
        Dieli utilise des services de notification afin d'informer les
        utilisateurs et les chauffeurs des événements liés au service, par
        exemple une nouvelle demande de course, l'évolution d'une réservation
        ou le statut d'une course.
      </p>

      <p>
        Les notifications peuvent être désactivées depuis les réglages de
        l'appareil.
      </p>

      <h2>6. Utilisation des données</h2>

      <p>Les données collectées peuvent notamment être utilisées pour :</p>

      <ul>
        <li>créer et gérer les comptes ;</li>
        <li>fournir le service de réservation de VTC ;</li>
        <li>mettre en relation passagers et chauffeurs ;</li>
        <li>calculer et traiter les courses et réservations ;</li>
        <li>traiter les paiements ;</li>
        <li>envoyer les notifications nécessaires au service ;</li>
        <li>assurer la sécurité et prévenir les utilisations frauduleuses ;</li>
        <li>répondre aux demandes d'assistance ;</li>
        <li>respecter nos obligations légales et réglementaires.</li>
      </ul>

      <h2>7. Partage des données</h2>

      <p>
        Certaines données peuvent être transmises aux prestataires techniques
        nécessaires au fonctionnement de Dieli, notamment pour l'hébergement,
        les paiements, les notifications, la cartographie et les services
        techniques associés.
      </p>

      <p>
        Certaines informations nécessaires à l'exécution d'une course peuvent
        également être échangées entre le passager et le chauffeur concerné.
      </p>

      <p>
        Dieli ne vend pas les données personnelles de ses utilisateurs.
      </p>

      <h2>8. Conservation des données</h2>

      <p>
        Les données sont conservées pendant la durée nécessaire à la fourniture
        du service, au respect de nos obligations légales et réglementaires,
        à la résolution des litiges et à la protection de nos intérêts
        légitimes.
      </p>

      <h2>9. Sécurité</h2>

      <p>
        Des mesures techniques et organisationnelles sont mises en œuvre afin
        de protéger les données personnelles contre l'accès non autorisé, la
        perte, l'altération ou la divulgation.
      </p>

      <h2>10. Vos droits</h2>

      <p>
        Conformément à la réglementation applicable en matière de protection
        des données, notamment le Règlement général sur la protection des
        données (RGPD), vous pouvez, selon les conditions prévues par la loi,
        demander l'accès, la rectification, l'effacement ou la limitation du
        traitement de vos données, ainsi qu'exercer vos autres droits
        applicables.
      </p>

      <p>
        Pour exercer vos droits, contactez-nous à :
        {" "}
        <a href="mailto:vtcontheroad@gmail.com">
          vtcontheroad@gmail.com
        </a>.
      </p>

      <p>
        Vous pouvez également introduire une réclamation auprès de l'autorité
        compétente en matière de protection des données.
      </p>

      <h2>11. Suppression du compte</h2>

      <p>
        Un utilisateur souhaitant supprimer son compte et les données
        personnelles associées peut en faire la demande depuis les
        fonctionnalités prévues dans l'application lorsqu'elles sont
        disponibles, ou en nous contactant à
        {" "}
        <a href="mailto:vtcontheroad@gmail.com">
          vtcontheroad@gmail.com
        </a>.
      </p>

      <h2>12. Modifications de cette politique</h2>

      <p>
        Cette politique peut être mise à jour afin de tenir compte des
        évolutions du service, de nos pratiques ou des obligations légales.
        La date de dernière mise à jour est indiquée en haut de cette page.
      </p>

      <h2>13. Contact</h2>

      <p>
        Pour toute question concernant cette politique de confidentialité ou
        le traitement de vos données personnelles :
      </p>

      <p>
        <strong>ON THE ROAD – Dieli</strong>
        <br />
        E-mail :{" "}
        <a href="mailto:vtcontheroad@gmail.com">
          vtcontheroad@gmail.com
        </a>
      </p>
    </main>
  );
}
